import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04422014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-user-details p-8 space-y-6 bg-white rounded-lg" }
const _hoisted_2 = { class: "process-user-header flex items-center gap-4" }
const _hoisted_3 = { class: "process-user-title text-3xl text-gray-700" }
const _hoisted_4 = { class: "process-user-actions flex justify-between" }
const _hoisted_5 = { class: "process-user-actions__primary space-x-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "process-user-actions__secondary" }
const _hoisted_8 = {
  key: 0,
  class: "space-y-5"
}
const _hoisted_9 = { class: "mb-3 text-xl text-gray-800" }
const _hoisted_10 = {
  key: 0,
  class: "mb-3 text-sm text-gray-500"
}
const _hoisted_11 = {
  key: 1,
  class: "mb-3 text-sm text-red-600"
}
const _hoisted_12 = {
  key: 2,
  class: "max-w-md"
}
const _hoisted_13 = {
  class: "block mb-2 text-sm text-gray-600",
  for: "signingMethodSelect"
}
const _hoisted_14 = ["value", "disabled"]
const _hoisted_15 = {
  value: "",
  disabled: ""
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { value: "EGOV_MOBILE" }
const _hoisted_18 = {
  key: 0,
  class: "mt-2 text-sm text-gray-500"
}
const _hoisted_19 = {
  key: 3,
  class: "text-sm text-gray-500"
}
const _hoisted_20 = {
  key: 4,
  class: "mt-2 text-sm text-amber-600"
}
const _hoisted_21 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_22 = { class: "text-sm text-gray-600" }
const _hoisted_23 = {
  key: 0,
  class: "inline-block text-green-500"
}
const _hoisted_24 = {
  key: 1,
  class: "p-4 border border-gray-200 rounded-lg"
}
const _hoisted_25 = { class: "text-gray-600" }
const _hoisted_26 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "space-y-2" }
const _hoisted_29 = { class: "text-gray-800 text-xl" }
const _hoisted_30 = { class: "mt-6" }
const _hoisted_31 = { class: "text-gray-800 text-xl" }
const _hoisted_32 = { class: "flex-grow p-3 bg-white rounded-lg" }
const _hoisted_33 = { class: "entity-details bg-white divide-y" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "flex-1 p-6 capitalize text-left text-gray-400" }
const _hoisted_36 = { class: "flex-1 p-6 text-left" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = { class: "flex-1 p-6 capitalize text-left text-gray-400" }
const _hoisted_39 = { class: "flex-1 p-6 text-left" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { class: "flex-1 p-6 capitalize text-left text-gray-400" }
const _hoisted_42 = { class: "flex-1 p-6 text-left" }
const _hoisted_43 = { class: "flex" }
const _hoisted_44 = { class: "flex-1 p-6 capitalize text-left text-gray-400" }
const _hoisted_45 = { class: "flex-1 p-6 text-left" }

import BackButton from "@/components/common/BackButton.vue";
import { ref, reactive, computed, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { TabButtons, InfoFields } from "@/components/common";
import {
  MainDocumentTable,
  AttachmentTable,
  ProcessHistory,
} from "@/components/documents/";
import DocumentHistory from "@/components/documents/DocumentHistory.vue";
import {
  DocumentDataService,
  FileDataService,
  ProcessUserDataService,
} from "@/services";
import { ProcessUserDetails, Document } from "@/types/";
import { useToast } from "vue-toastification";
import InfoList from "@/components/documents/InfoList.vue";
import ProcessUserStatusLabel from "@/components/documents/ProcessUserStatusLabel.vue";
import LinkedDocuments from "@/components/documents/LinkedDocuments.vue";
import EgovMobileSignModal from "@/components/documents/EgovMobileSignModal.vue";
import { t } from "@/i18n";
import { resolveLocalizedMap } from "@/utils/localization";
import {
  base64ToFile,
  createCmsSignatureFromBase64,
} from "@/utils/ncaLayer";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();

const toast = useToast();
const mainGuid = ref();
const mainFileInfo = ref();
const processUser = ref<ProcessUserDetails>();
const document = ref<Document>();
const files = ref<unknown[]>([]);
const attachedDocuments = ref([]);
const ncaSignatureSaved = ref(false);
const signedStatus = computed(
  () => processUser.value?.processUserEvents.signedFileStatus
);
const packageSigned = computed(() => {
  if (ncaSignatureSaved.value) {
    return true;
  }
  const status = signedStatus.value;
  if (!status) {
    return false;
  }
  const values = Object.values(status);
  return values.length > 0 && values.every(Boolean);
});
const localizedProcessName = computed(() => {
  const template = processUser.value?.processUserInfo.process.templateInfo;
  return resolveLocalizedMap(template?.nameI18n, template?.name || "");
});

const comment = ref("");
const documentStatus = ref<string | undefined>(undefined);
const buildDisplayFileName = (item: any) => `${item.name}${item.ext || ""}`;
const isMobileDevice = /Android|iPhone|iPad|iPod|Mobile/i.test(
  typeof navigator !== "undefined" ? navigator.userAgent : ""
);
const signingMethod = ref<"NCALAYER" | "EGOV_MOBILE" | null>(null);
const showEgovMobileModal = ref(false);
const mobileSessionActive = ref(false);
const egovSessionReady = ref(false);
const egovSessionInfo = ref<{
  urlFl?: string;
  qrSvg?: string;
  urlQr?: string;
  status?: string;
} | null>(null);
const ncaSigningInProgress = ref(false);
const signingAvailabilityLoading = ref(true);
const signingAvailabilityError = ref(false);

const signingHint = computed(() => {
  if (signingMethod.value === "NCALAYER") {
    return t("process.ncaLayerHint");
  }
  if (signingMethod.value === "EGOV_MOBILE") {
    return isMobileDevice
      ? t("process.egovMobileHintMobile")
      : t("process.egovMobileHintDesktop");
  }
  return "";
});

const egovActionLabel = computed(() => {
  if (!mobileSessionActive.value) {
    return isMobileDevice
      ? t("process.openEgovMobile")
      : t("process.generateQrCode");
  }
  if (isMobileDevice && egovSessionInfo.value?.urlFl) {
    return t("process.openEgovMobile");
  }
  return t("process.continueSigning");
});

const signingActionLabel = computed(() => {
  if (signingMethod.value === "NCALAYER") {
    return ncaSigningInProgress.value
      ? t("process.waitingNcaLayer")
      : t("process.signWithNcaLayer");
  }
  if (signingMethod.value === "EGOV_MOBILE") {
    return egovActionLabel.value;
  }
  return processUser.value?.processUserEvents.actionName || t("process.execute");
});

const signingActionDisabled = computed(() => {
  if (!signingMethod.value) {
    return true;
  }
  if (signingAvailabilityLoading.value || signingAvailabilityError.value) {
    return true;
  }
  if (signingMethod.value === "NCALAYER") {
    return ncaSigningInProgress.value;
  }
  return false;
});

const canShowDeny = computed(() => {
  if (!processUser.value?.processUserEvents?.canDeny) {
    return false;
  }
  return !mobileSessionActive.value || egovSessionReady.value;
});

const updateDocument = async () => {
  await router.push({
    name: "DocumentEdit",
    params: { id: document.value?.id },
  });
};

const deleteDocument = async () => {
  await DocumentDataService.delete(document.value?.id as number);
  await router.push({ name: "DocumentList" });
};

const sendDocumentForExecution = async () => {
  await DocumentDataService.sendForExecution(document.value?.id);
  router.go(0);
};

const returnDocument = async () => {
  await DocumentDataService.returnDocument(document.value?.id);
  router.go(0);
};

const mainDocumentGuid = () => {
  document.value?.documentFiles.forEach(function (file) {
    if (file.type === "MAIN") {
      mainGuid.value = file.fileGuid;
      mainFileInfo.value = file;
    }
  });
};

const executeProcess = async (executionType: "EXECUTE" | "DENY" | "REWORK") => {
  if (!processUser.value) return;
  if (executionType === "DENY" && !comment.value.trim()) {
    toast.error(t("sign.enter_comment"));
    return;
  }
  try {
    const response = await ProcessUserDataService.execute(
      processUser.value.processUserInfo.id,
      executionType,
      comment.value
    );
    toast.success(response.data.message);
    await router.push({ name: "DocumentList" });
  } catch (error: any) {
    toast.error(
      error?.response?.data?.data?.executeSignProcess ||
        error?.response?.data?.message ||
        error?.message
    );
  }
};

const selectSigningMethod = (method: "NCALAYER" | "EGOV_MOBILE") => {
  if (signingAvailabilityLoading.value || signingAvailabilityError.value) {
    return;
  }
  if (method === "NCALAYER" && isMobileDevice) {
    toast.warning(t("process.mobileOnlyWarning"));
    return;
  }
  if (method === "EGOV_MOBILE" && ncaSigningInProgress.value) {
    toast.warning(t("process.waitNcaLayerWarning"));
    return;
  }
  if (method === "NCALAYER" && mobileSessionActive.value) {
    toast.warning(t("process.finishMobileSessionWarning"));
    return;
  }
  signingMethod.value = method;
  if (method === "EGOV_MOBILE") {
    showEgovMobileModal.value = true;
  } else {
    egovSessionReady.value = false;
    egovSessionInfo.value = null;
  }
};

const onSigningMethodChange = (event: Event) => {
  const value = (event.target as HTMLSelectElement).value;
  if (value !== "NCALAYER" && value !== "EGOV_MOBILE") {
    return;
  }
  selectSigningMethod(value);
};

const handleSigningAction = async () => {
  if (signingActionDisabled.value) {
    return;
  }
  if (signingMethod.value === "NCALAYER") {
    await handleNcaLayerSigning();
    return;
  }
  if (signingMethod.value === "EGOV_MOBILE") {
    openEgovMobileFlow();
  }
};

const openEgovMobileFlow = () => {
  if (
    isMobileDevice &&
    mobileSessionActive.value &&
    egovSessionInfo.value?.urlFl
  ) {
    window.location.href = egovSessionInfo.value.urlFl;
    return;
  }
  showEgovMobileModal.value = true;
};

const onEgovSessionStarted = (info?: any) => {
  mobileSessionActive.value = true;
  if (info) {
    onEgovSessionUpdated(info);
  }
};

const onEgovSessionUpdated = (info: any) => {
  egovSessionInfo.value = info || null;
};

const onEgovSessionReady = (info: any) => {
  mobileSessionActive.value = true;
  egovSessionReady.value = true;
  egovSessionInfo.value = info || null;
};

const restoreMobileSignSession = async () => {
  if (!processUser.value?.processUserInfo.id) return;
  signingAvailabilityLoading.value = true;
  signingAvailabilityError.value = false;
  let shouldAutoSelectEgov = false;
  try {
    const response = await ProcessUserDataService.getActiveMobileSign(
      processUser.value.processUserInfo.id
    );
    if (response.data.data) {
      signingMethod.value = "EGOV_MOBILE";
      mobileSessionActive.value = true;
      onEgovSessionReady(response.data.data);
      showEgovMobileModal.value = true;
    } else if (isMobileDevice) {
      shouldAutoSelectEgov = true;
    }
  } catch (error: any) {
    signingAvailabilityError.value = true;
    toast.error(
      error?.response?.data?.message ||
        t("process.mobileSessionCheckError")
    );
  } finally {
    signingAvailabilityLoading.value = false;
  }
  if (shouldAutoSelectEgov) {
    selectSigningMethod("EGOV_MOBILE");
  }
};

const handleMobileTerminal = (status: string) => {
  if (
    status === "FAILED" ||
    status === "EXPIRED" ||
    status === "CANCELLED"
  ) {
    mobileSessionActive.value = false;
    egovSessionReady.value = false;
  }
};

const handleMobileCancelled = () => {
  signingMethod.value = null;
  mobileSessionActive.value = false;
  egovSessionReady.value = false;
  egovSessionInfo.value = null;
  showEgovMobileModal.value = false;
};

const handleMobileCompleted = async () => {
  mobileSessionActive.value = false;
  egovSessionReady.value = false;
  egovSessionInfo.value = null;
  showEgovMobileModal.value = false;
  toast.success(t("process.mobileSigningSuccess"));
  await router.push({ name: "DocumentList" });
};

const handleNcaLayerSigning = async () => {
  if (ncaSigningInProgress.value) return;

  if (packageSigned.value) {
    ncaSigningInProgress.value = true;
    try {
      await executeProcess("EXECUTE");
    } finally {
      ncaSigningInProgress.value = false;
    }
    return;
  }

  await signPackage();
};

const signPackage = async () => {
  const processUserId = processUser.value?.processUserInfo.id;
  if (!processUserId || ncaSigningInProgress.value) return;
  ncaSigningInProgress.value = true;

  let manifestResponse: any;
  try {
    manifestResponse = await ProcessUserDataService.getSignManifest(
      processUserId
    );
  } catch (error: any) {
    ncaSigningInProgress.value = false;
    toast.error(
      error?.response?.data?.message || t("process.manifestLoadError")
    );
    return;
  }

  try {
    const base64 = manifestResponse.data.data;
    const cmsBase64 = await createCmsSignatureFromBase64(base64);
    const file = await base64ToFile(
      cmsBase64,
      `${processUserId}_signature.cms`,
      "application/cms"
    );
    const { data } = await FileDataService.upload(file);
    const response = await ProcessUserDataService.signManifest(
      processUserId,
      data.data.fileGuid
    );
    ncaSignatureSaved.value = true;
    toast.success(response.data.message);
    await executeProcess("EXECUTE");
  } catch (error: any) {
    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        t("process.ncaLayerConnectionError")
    );
  } finally {
    ncaSigningInProgress.value = false;
  }
};

const documentDetails = computed(() => {
  return {
    regNumber: document.value?.documentInfo.regNumber || "",
    categoryName: document.value?.constructorInfo.name,
    createdBy: document.value?.creatorInfo?.userInfo.fullName,
    theme: document.value?.documentInfo.title,
    index: document.value?.documentInfo.nomenclatureInfo.name,
    createdAt: document.value?.creatorInfo.createdAt,
    status: document.value?.status,
  };
});

const mainDocumentInfo = computed(() => ({
  creator: document.value?.creatorInfo?.userInfo.fullName,
  description: document.value?.documentInfo.description,
  createdAt: document.value?.creatorInfo.createdAt,
  fileGuid: mainGuid.value,
  filename: mainFileInfo.value ? buildDisplayFileName(mainFileInfo.value) : "",
  fileType: mainFileInfo.value?.type,
  fileExt: mainFileInfo.value?.ext,
}));

const attachments = ref([]);

const accessText: Record<string, string> = {
  VIEW: t("process.access.view"),
  CREATOR: t("process.access.creator"),
};

const accesses = computed(
  () =>
    new Map(
      document.value?.documentAccesses.map((access) => [
        access.userInfo.fullName,
        accessText[access.type],
      ])
    )
);

const processes = computed(() =>
  document.value?.documentProcesses
    .slice()
    .sort((prev, next) => prev.id - next.id)
);

const tabOptions = [
  t("process.tab.requisites"),
  t("process.tab.content"),
  t("process.tab.attachments"),
  t("process.tab.processes"),
  t("process.tab.history"),
  t("process.tab.accessRights"),
  t("process.tab.linkedDocuments"),
];
const currentTab = ref(t("process.tab.requisites"));

const tabComponents = {
  [t("process.tab.requisites")]: InfoList,
  [t("process.tab.content")]: MainDocumentTable,
  [t("process.tab.attachments")]: AttachmentTable,
  [t("process.tab.processes")]: ProcessHistory,
  [t("process.tab.history")]: DocumentHistory,
  [t("process.tab.accessRights")]: InfoFields,
  [t("process.tab.linkedDocuments")]: LinkedDocuments,
};

const documentGuid = computed(() => {
  return document.value?.guid;
});
const documentId = computed(() => document.value?.id);

const tabProps = reactive({
  [t("process.tab.requisites")]: {
    data: documentDetails,
  },
  [t("process.tab.content")]: {
    file: mainDocumentInfo,
    documentId,
  },
  [t("process.tab.attachments")]: {
    files: attachments,
    documentId,
  },
  [t("process.tab.processes")]: {
    processes,
    documentStatus,
  },
  [t("process.tab.history")]: {
    documentGuid: documentGuid,
  },
  [t("process.tab.accessRights")]: {
    data: accesses,
  },
  [t("process.tab.linkedDocuments")]: {
    linkedDocuments: computed(() =>
      (document.value?.linkedDocuments || []).map((linkedDocument) => ({
        id: linkedDocument.id,
        name:
          linkedDocument.documentInfo?.title ||
          linkedDocument.documentInfo?.regNumber ||
          `Document #${linkedDocument.id}`,
      }))
    ),
  },
});

const createLinkedDocument = async () => {
  // console.log(document.value?.id);
  await router.push({
    name: "DocumentCreate",
    params: { linkedDocumentId: document.value?.id },
  });
};

let processUserLoadSequence = 0;

const loadProcessUserDetails = async (id: string) => {
  const loadSequence = ++processUserLoadSequence;

  processUser.value = undefined;
  document.value = undefined;
  files.value = [];
  attachedDocuments.value = [];
  attachments.value = [];
  mainGuid.value = undefined;
  mainFileInfo.value = undefined;
  documentStatus.value = undefined;
  comment.value = "";
  signingMethod.value = null;
  showEgovMobileModal.value = false;
  mobileSessionActive.value = false;
  egovSessionReady.value = false;
  egovSessionInfo.value = null;
  signingAvailabilityLoading.value = true;
  signingAvailabilityError.value = false;

  const response = await ProcessUserDataService.get(id);
  if (loadSequence !== processUserLoadSequence) return;

  processUser.value = response.data.data;
  document.value = response.data.data.document;
  mainDocumentGuid();

  if (processUser.value?.processUserEvents?.isSigning) {
    await restoreMobileSignSession();
    if (loadSequence !== processUserLoadSequence) return;
  } else {
    signingAvailabilityLoading.value = false;
  }

  const fileGuids = document.value?.documentFiles.map((file) => file.fileGuid) || [];
  const [filesResponse, attachedFilesResponse] = await Promise.all([
    FileDataService.getFilesInfo(fileGuids),
    DocumentDataService.getFilesInfo(fileGuids),
  ]);
  if (loadSequence !== processUserLoadSequence) return;

  files.value = filesResponse.data;
  documentStatus.value = document.value?.status;
  attachedDocuments.value = attachedFilesResponse.data;
  attachedDocuments.value.forEach((item: any) => {
    if (item.guid === mainGuid.value) {
      mainFileInfo.value = item;
    } else {
      attachments.value.push({
        creator: document.value?.creatorInfo.userInfo.fullName,
        guid: item.guid,
        filename: buildDisplayFileName(item),
        createdAt: item.createdAt,
        fileType: item.type,
        ext: item.ext,
      });
    }
  });
};

onMounted(() => loadProcessUserDetails(String(route.params.id)));

watch(
  () => route.params.id,
  (id, previousId) => {
    if (id !== previousId) {
      loadProcessUserDetails(String(id));
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'ProcessUsersList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(document.value?.documentInfo.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.$route.name === 'ProcessUserDetails')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (
              processUser.value?.processUserEvents.canExecute &&
              !processUser.value?.processUserEvents.isSigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "px-4 py-2 text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-100",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (executeProcess('EXECUTE')))
                    }, _toDisplayString(processUser.value?.processUserEvents.actionName || _unref(t)("process.execute")), 1))
                  : _createCommentVNode("", true),
                (processUser.value?.processUserEvents.canSendForRework)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "px-4 py-2 text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-100",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (executeProcess('REWORK')))
                    }, _toDisplayString(_unref(t)("process.returnForRework")), 1))
                  : _createCommentVNode("", true),
                (
              processUser.value?.processUserEvents.canDeny &&
              _unref(canShowDeny) &&
              !processUser.value?.processUserEvents.isSigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "px-4 py-2 text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-100",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (executeProcess('DENY')))
                    }, _toDisplayString(_unref(t)("process.deny")), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.$route.name === 'DocumentDetails')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([
              {
                title: _unref(t)('process.edit'),
                show: _ctx.events.canUpdate,
                action: () => {
                  updateDocument();
                },
              },
              {
                title: _unref(t)('process.send'),
                show: _ctx.events.canSendForExecution,
                action: () => {
                  sendDocumentForExecution();
                },
              },
              {
                title: _unref(t)('process.return'),
                show: _ctx.events.canReturn,
                action: () => {
                  returnDocument();
                },
              },
              {
                title: _unref(t)('process.delete'),
                show: _ctx.events.canDelete,
                action: () => {
                  deleteDocument();
                },
              },
            ], ({ title, show, action }) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: title }, [
                    show
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "px-4 py-2 border border-gray-300 rounded-lg text-gray-800 hover:bg-gray-100",
                          onClick: action
                        }, _toDisplayString(title), 9, _hoisted_6))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "px-4 py-2 border border-gray-300 rounded-lg text-gray-800 hover:bg-gray-100",
            onClick: createLinkedDocument
          }, _toDisplayString(_unref(t)("process.createLinkedDocument")), 1)
        ])
      ]),
      (processUser.value?.processUserEvents?.isSigning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(t)("process.signingMethod")), 1),
              (signingAvailabilityLoading.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(t)("process.signingSessionsLoading")), 1))
                : (signingAvailabilityError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(t)("process.signingSessionsError")), 1))
                  : _createCommentVNode("", true),
              (!_unref(isMobileDevice) || !signingMethod.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)("process.selectSigningMethod")), 1),
                    _createElementVNode("select", {
                      id: "signingMethodSelect",
                      class: "signing-method-select w-full border border-gray-300 rounded-lg",
                      value: signingMethod.value || '',
                      disabled: 
              signingAvailabilityLoading.value ||
              signingAvailabilityError.value ||
              (mobileSessionActive.value && signingMethod.value === 'EGOV_MOBILE')
            ,
                      onChange: onSigningMethodChange
                    }, [
                      _createElementVNode("option", _hoisted_15, _toDisplayString(_unref(t)("process.selectSigningMethod")), 1),
                      _createElementVNode("option", {
                        value: "NCALAYER",
                        disabled: mobileSessionActive.value || _unref(isMobileDevice)
                      }, _toDisplayString(_unref(t)("process.ncaLayerOption")), 9, _hoisted_16),
                      _createElementVNode("option", _hoisted_17, _toDisplayString(_unref(t)("process.egovMobileOption")), 1)
                    ], 40, _hoisted_14),
                    (signingMethod.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(signingHint)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(signingHint)), 1)),
              (mobileSessionActive.value && !_unref(isMobileDevice))
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(t)("process.activeMobileSession")), 1))
                : _createCommentVNode("", true)
            ]),
            (signingMethod.value === 'NCALAYER')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)("process.ncaManifestSigning")), 1),
                  (_unref(packageSigned))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)("process.packageSigned")) + " ✓ ", 1))
                    : _createCommentVNode("", true)
                ]))
              : (signingMethod.value === 'EGOV_MOBILE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(signingHint)), 1)
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                disabled: _unref(signingActionDisabled),
                class: "signing-action-button px-4 text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed",
                onClick: handleSigningAction
              }, _toDisplayString(_unref(signingActionLabel)), 9, _hoisted_27),
              (processUser.value?.processUserEvents.canDeny && _unref(canShowDeny))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "signing-action-button px-4 text-white bg-red-600 rounded-lg hover:bg-red-700",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (executeProcess('DENY')))
                  }, _toDisplayString(_unref(t)("process.deny")), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h2", _hoisted_29, _toDisplayString(_unref(t)("process.comments")), 1),
          _withDirectives(_createElementVNode("textarea", {
            name: "comment",
            class: "w-full h-24 border-gray-300 rounded-lg",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((comment).value = $event))
          }, null, 512), [
            [_vModelText, comment.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("h2", _hoisted_31, _toDisplayString(_unref(t)("process.info")), 1),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("ul", _hoisted_33, [
              _createElementVNode("li", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)("process.name")), 1),
                _createElementVNode("div", _hoisted_36, _toDisplayString(processUser.value ? _unref(localizedProcessName) : _unref(t)("process.noData")), 1)
              ]),
              _createElementVNode("li", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)("process.executor")), 1),
                _createElementVNode("div", _hoisted_39, _toDisplayString(processUser.value
                    ? processUser.value.processUserInfo.userInfo.fullName
                    : _unref(t)("process.noData")), 1)
              ]),
              _createElementVNode("li", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)("process.comment")), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(processUser.value
                    ? processUser.value.processUserInfo.process.comment
                    : _unref(t)("process.noData")), 1)
              ]),
              _createElementVNode("li", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)("process.status")), 1),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(ProcessUserStatusLabel, {
                    label: processUser.value?.processUserInfo.status
                  }, null, 8, ["label"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_unref(TabButtons), {
        options: tabOptions,
        modelValue: currentTab.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentTab).value = $event)),
        class: "w-full text-md"
      }, null, 8, ["modelValue"]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(tabComponents[currentTab.value]), _normalizeProps(_guardReactiveProps(_unref(tabProps)[currentTab.value])), null, 16)),
      (processUser.value?.processUserInfo?.id)
        ? (_openBlock(), _createBlock(EgovMobileSignModal, {
            key: 1,
            show: showEgovMobileModal.value,
            "process-user-id": processUser.value.processUserInfo.id,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (showEgovMobileModal.value = false)),
            onSessionStarted: onEgovSessionStarted,
            onSessionReady: onEgovSessionReady,
            onSessionUpdated: onEgovSessionUpdated,
            onTerminal: handleMobileTerminal,
            onCompleted: handleMobileCompleted,
            onCancelled: handleMobileCancelled
          }, null, 8, ["show", "process-user-id"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})